export const selectActionResolutions = (state) => state.actionResolutions.actionResolutions;

export const selectActionResolutionsLoading = (state) => state.actionResolutions.loading;
export const selectActionResolutionsError = (state) => state.actionResolutions.error;